import { useParams } from 'react-router-dom';
import useUsuarioCadastro from '../../../../hooks/useUsuarioCadastro';
import { Loader } from '../../../../shared/components/Loader';
import Box from '@mui/material/Box';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import Typography from '@mui/material/Typography';
import { Input } from '../../../../shared/components/Input';
import { HeaderFormActions } from '../../../../shared/components/HeaderFormActions';
import { useLocation} from 'react-router-dom';
import { PapeisDoUsuario } from './PapeisDoUsuario';

export default function UsuarioCadastrar() {
  const { id } = useParams();
  const userId = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  const {
    handleBlur,
    values,
    handleChange,
    errors,
    touched,
    handleSubmit,
    backActions,
    loading,
  } = useUsuarioCadastro(userId);

  return (
    <Loader loading={loading}>
      <HeaderComponent text={'Cadastro'} />
      <Box className='p-3'>
        <form autoComplete='off' onSubmit={handleSubmit} name='customer-detail'>
          <Box className='grid grid-cols-8 gap-7 pt-4'>
            <Box className='col-span-6'>
              <HeaderFormActions backActions={() => backActions()} duploClick={duploClick}/>
            </Box>

            <Typography className='col-span-8' variant='h6'>
              Dados Pessoal
            </Typography>
          </Box>            
            <fieldset disabled={duploClick}>
            <Box className='grid grid-cols-8 gap-7 pt-4'>
            <Input
              label='Nome'
              className='col-span-3'
              name='usu_nome'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.usu_nome && errors.usu_nome ? errors.usu_nome : ''}
              hasError={!!(touched.usu_nome && errors.usu_nome)}
              value={values.usu_nome}
            />
            <Input
              label='Login'
              className='col-span-2'
              name='usu_login'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={
                touched.usu_login && errors.usu_login ? errors.usu_login : ''
              }
              hasError={!!(touched.usu_login && errors.usu_login)}
              value={values.usu_login}
            />
            {/* [22/10] A SENHA SAIU DA TELA. Ninguém digita senha de ninguém: ao salvar,
                a API gera uma temporária, guarda cifrada e envia por e-mail à pessoa, que
                troca no primeiro acesso. Enquanto o administrador digitava a senha, ele
                conhecia a de todo mundo que cadastrava — e, como ninguém trocava, para
                sempre. */}
            <Input
              label='E-mail'
              className='col-span-3'
              name='usu_email'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={
                touched.usu_email && errors.usu_email ? errors.usu_email : ''
              }
              hasError={!!(touched.usu_email && errors.usu_email)}
              value={values.usu_email}
            />
          </Box>
          </fieldset>
        </form>

        {/* [22/10] Os papéis ficam FORA do <form> e gravam por conta própria: são outra
            chamada à API, que pode ser recusada sozinha (a trava do último administrador).
            Dentro do mesmo submit, uma recusa viraria "usuário salvo com sucesso" com o
            papel não gravado. */}
        <PapeisDoUsuario usuarioId={userId} />
      </Box>
    </Loader>
  );
}
